var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    staticClass: "home"
  }, [_c('b-row', {
    staticClass: "mx-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('h2', {
    staticClass: "stores"
  }, [_vm._v(_vm._s(_vm.$t("store")))])]), _c('b-col', {
    staticClass: "search-options",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-select', {
    staticClass: "mt-1",
    attrs: {
      "options": _vm.options2
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1), _c('b-col', {
    staticClass: "search-options",
    attrs: {
      "md": "3"
    }
  }, [_vm.showMarketOption ? _c('b-form-select', {
    staticClass: "mt-1",
    attrs: {
      "options": _vm.marketOptions
    },
    on: {
      "input": _vm.distanceFilter
    },
    model: {
      value: _vm.selectedMarketOption,
      callback: function ($$v) {
        _vm.selectedMarketOption = $$v;
      },
      expression: "selectedMarketOption"
    }
  }) : _c('div', {
    staticClass: "d-flex mt-1"
  }, [_c('b-form-input', {
    staticClass: "search-storeinput",
    attrs: {
      "placeholder": _vm.$t('searchStore')
    },
    model: {
      value: _vm.storeName,
      callback: function ($$v) {
        _vm.storeName = $$v;
      },
      expression: "storeName"
    }
  }), _c('button', {
    staticClass: "col search-button mt-3 border-radius-r-40",
    on: {
      "click": _vm.storeResult
    }
  }, [_c('b-icon', {
    staticClass: "margin-top-4",
    attrs: {
      "icon": "search"
    }
  })], 1)], 1)], 1), _c('b-col', {
    staticClass: "search-options",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-select', {
    staticClass: "mt-1",
    attrs: {
      "options": _vm.options
    },
    on: {
      "input": _vm.distanceFilter
    },
    model: {
      value: _vm.selectedDistance,
      callback: function ($$v) {
        _vm.selectedDistance = $$v;
      },
      expression: "selectedDistance"
    }
  })], 1)], 1), _c('sections-slider', {
    attrs: {
      "list": _vm.paginatedStoreItems,
      "subTitle": "",
      "hasBackground": true,
      "showTitle": true,
      "hasButton": false,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box product-listing-div"
        }, [_c('router-link', {
          staticStyle: {
            "text-decoration": "none",
            "color": "inherit"
          },
          attrs: {
            "to": {
              name: `shopDetails`,
              params: {
                id: listItem._id,
                items: listItem.office.officeName
              }
            }
          }
        }, [_c('items-item', {
          attrs: {
            "itemWhiteBg": true,
            "product": listItem
          }
        })], 1)], 1)];
      }
    }])
  }), _c('b-pagination', {
    attrs: {
      "total-rows": _vm.newStore.length,
      "per-page": _vm.perPage,
      "pills": "",
      "align": "right",
      "aria-controls": "my-table"
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }